export const ERROR_MESSAGES: Record<string, string> = {
  EMAIL_EMPTY: '이메일을 입력해주세요.',
  EMAIL_DUPLICATED: '이미 사용된 이메일입니다.',
  EMAIL_INVALID: '유효하지 않은 이메일입니다.',
  NAME_EMPTY: '닉네임을 입력해주세요.',
  NAME_DUPLICATED: '이미 사용된 닉네임입니다.',
  NAME_INVALID: '한글, 영문, 숫자로 된 2 ~ 10자리를 입력해주세요.',
  PASSWORD_INVALID: '영문, 숫자, 특수문자 포함한 8 ~ 16자리를 입력해주세요.',
  PASSWORD_EMPTY: '비밀번호를 입력해주세요.',
  CONFIRM_INCORRECT: '비밀번호와 일치하지 않습니다.',
  UNEXPECTED: '예기치 못한 오류가 발생했습니다.',
  INVALID_LOGIN: '아이디 또는 비밀번호가 맞지 않습니다.',
};
